import React, { useState, useEffect } from "react";
import "./Wishlist.css";

const Wishlist = () => {
  const [wishlist, setWishlist] = useState([]);

  useEffect(() => {
    const fetchWishlist = async () => {
      try {
        const response = await fetch("https://backend.rubiajewels.com/api/wishlist", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch wishlist");
        }

        const data = await response.json();
        setWishlist(data); 
      } catch (error) {
        console.error("Error fetching wishlist:", error);
      }
    };

    fetchWishlist();
  }, []); 

  const removeFromWishlist = async (wishlistItemId) => {
    try {
      const response = await fetch(
        `https://backend.rubiajewels.com/api/wishlist/${wishlistItemId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to remove item from wishlist");

      setWishlist((prev) => {
        const updatedWishlist = prev.filter(
          (item) => item._id !== wishlistItemId
        );

        localStorage.setItem("wishlist", JSON.stringify(updatedWishlist));

        return updatedWishlist;
      });
    } catch (error) {
      console.error("Error removing from wishlist:", error);
    }
  };

  return (
    <div className="wishlist">
      <h4 className="wishlist-title">My Wishlist</h4>
      {wishlist.length === 0 ? (
        <p>Wishlist is empty.</p>
      ) : (
        <div className="wishlist-container">
          {wishlist.map((item) => (
            <div key={item._id} className="wishlist-item">
              <button
                className="remove-item"
                onClick={() => removeFromWishlist(item._id)}
                aria-label="Remove item"
              >
                &times;
              </button>
              <img
                src={`https://backend.rubiajewels.com/${item.image}`}
                alt={item.name}
              />
              <h3>{item.name}</h3>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Wishlist;